/**
 * @owner @Appboy/whats-app
 * WhatsApp Template Message GET Schema
 *
 * This schema is specifically for template messages (whats_app_message_type = "template").
 * Used for type narrowing in validators.
 */

import { z } from "zod";
import { whatsAppMessagingServiceSchema } from "./whatsAppMessagingServiceSchema";
import { whatsAppTemplateMessageCommonSchema } from "@schemas/message/whatsAppTemplateMessageCommonSchema";
import { messageGetBaseSchema } from "@schemas/message/messageGetBaseSchema";

// Refer to whatsapp-message.ko.ts fromAjaxData (accepts GET shape)
export const whatsAppTemplateMessageGetSchema = z.object({
  ...messageGetBaseSchema.shape,
  ...whatsAppTemplateMessageCommonSchema.shape,
  selected_messaging_service: whatsAppMessagingServiceSchema,
});
